<script lang="ts" setup>
import { useUser } from "#imports";
const userStore = useUser();
defineProps<{
  menuItems: {
    id: string;
    label: string;
    showLabel: boolean;
    withSlot?: boolean;
    withDivider?: boolean;
    items?: {
      label: string;
      icon?: string;
      isActive?: boolean;
      creatorsOnly?: boolean;
      action: () => void;
    }[];
  }[];
  theme?: string;
}>();
</script>

<template>
  <nav>
    <ul>
      <li v-for="menu in menuItems" :key="menu.id">
        <label v-if="menu.showLabel">{{ menu.label }}</label>
        <ul v-if="menu.items" class="menu-items">
          <li
            v-for="(item, idx) in menu.items"
            :key="idx"
            :class="{ active: item.isActive }"
          >
            <a
              @click="item.action"
              v-if="item.creatorsOnly ? userStore.user.is_creator : true"
            >
              <i v-if="item.icon" :class="item.icon" />
              {{ item.label }}
            </a>
          </li>
        </ul>
        <div class="menu-slot">
          <slot v-if="menu.withSlot" :name="menu.id" />
        </div>
        <hr v-if="menu.withDivider" />
      </li>
    </ul>
  </nav>
</template>

<style scoped>
nav ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

nav ul {
  display: grid;
  align-items: center;
  gap: 0.5rem;
}

nav ul li a,
nav ul li label {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.25rem;
  text-decoration: none;
  position: relative;
  transition: padding-left 0.3s ease;
  border-radius: 0.5rem;
  font-weight: 500;
}

nav ul.menu-items li a:after {
  font-family: "RemixIcon";
  content: "\EA6E";
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--color-slate-400);
}

nav ul.menu-items li i {
  color: var(--color-slate-400);
  font-size: 1.25rem;
}

nav ul li.active a {
  background-color: var(--color-rose-400);
  color: var(--color-rose-50);
}

nav ul li.active a i {
  color: var(--color-rose-100);
}

nav ul.menu-items li.active a:after {
  color: var(--color-rose-200);
}

nav ul li a:hover {
  cursor: pointer;
  padding-left: 0.75rem;
  transition: padding-left 0.3s ease;
}

hr {
  border: none;
  border-top: 1px solid var(--color-slate-300);
  opacity: 0.25;
  margin: 0.5rem 0;
}

.menu-slot {
  padding: 0.5rem 0.25rem 0;
}
</style>
